var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#361A52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3746 5.17726L9.41585 5.13602L9.3746 5.09477L8.9046 4.62477L8.86335 4.58352L8.82211 4.62477L7.00002 6.44685L5.17793 4.62477L5.13669 4.58352L5.09544 4.62477L4.62544 5.09477L4.58419 5.13602L4.62544 5.17726L6.44752 6.99935L4.62544 8.82143L4.58419 8.86268L4.62544 8.90393L5.09544 9.37393L5.13669 9.41518L5.17793 9.37393L7.00002 7.55184L8.82211 9.37393L8.86335 9.41518L8.9046 9.37393L9.3746 8.90393L9.41585 8.86268L9.3746 8.82143L7.55252 6.99935L9.3746 5.17726Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.116667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.ed8153fa16d36bd5a3293b62862deec6.svg";
export { ForwardRef as ReactComponent };